<script setup>
import { textToHtml } from '@0x234/common-util/html';
import { cleanUrl } from '@0x234/common-util/url';
import { computed } from 'vue';

const $props = defineProps({
    company: {
        type: Object,
        required: true
    }
});

const hasDetails = computed(() => Boolean($props.company.location || $props.company.size || $props.company.websiteUrl));
const hasDescription = computed(() => Boolean($props.company.description));
</script>

<template>
    <div class="company-profile-card">
        <h4 class="q-mt-sm q-mb-lg">
            About {{ company.name }}
        </h4>
        <div v-if="hasDetails" class="company-details row q-col-gutter-sm q-mt-lg q-mb-lg">
            <div v-if="company.location" class="col-12 flex items-center">
                <q-icon name="sym_r_home_pin" size="sm"/>
                <span class="q-ml-sm">{{ company.location.name }}</span>
            </div>
            <div v-if="company.classification" class="col-12 flex items-center">
                <q-icon name="sym_r_apartment" size="sm"/>
                <span class="q-ml-sm">{{ company.classification.name }}</span>
            </div>
            <div v-if="company.size" class="col-12 flex items-center">
                <q-icon name="sym_r_group" size="sm"/>
                <span class="q-ml-sm">{{ company.size }} employees</span>
            </div>
            <div v-if="company.websiteUrl" class="col-12 flex items-center">
                <q-icon name="sym_r_public" size="sm"/>
                <span class="q-ml-sm"><a :href="company.websiteUrl" target="_blank">{{ cleanUrl(company.websiteUrl) }}</a></span>
            </div>
        </div>
        <div v-if="hasDescription" class="company-description" v-html="textToHtml(company.description)"></div>
        <div v-else class="text-italic">
            <p v-if="company.role === 'Direct'">
                This company does not have any further information provided at this time. We encourage you to research the company by searching for them to learn more about their
                culture and values before applying for the role.
            </p>
            <p v-else>
                This company does not have any further information provided at this time. We encourage you to research the company by searching for them to learn more about the
                company or role in question before applying.
            </p>
        </div>
    </div>
</template>
